import React from "react"
import ReactDOM from "react-dom"
import App from "./conponents/App.js"
import registerServiceWorker from "./registerServiceWorker"
import "./styles/index.css"

ReactDOM.render(
	<App />,
	document.getElementById("root")
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js